export const maintenanceWorkflowStatus: Record<string, string> = {
  pending: 'Pendente',
  in_progress: 'Em andamento',
  completed: 'Completo',
  canceled: 'Cancelado',
}
